import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";

import ExpertCatReportSub from "./ExpertCatReportSub"

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const ExpertCatReport = (props) => {

    const [services, setServices] = useState([]);
    const [subservices, setSubservices] = useState([]);
    const [regions, setRegions] = useState([]);

    useEffect(() => {
        apiGet(`intranetexperts/getexpertcat/`).then(res => {
            res.json().then(data => {
              setServices(data.services)
              setRegions(data.regions)
              setSubservices(data.subservices)
            })
          })
      }, [])
      //console.log(subservices)
      let i = -1
    return(
        <Container>
            {
                Object.entries(subservices).map(([key, value]) => {
                    i++
                    return(
                        <div className="section">
                            <h3>{services[i]}</h3>
                            
                            <ExpertCatReportSub tablename={key} subservices={value} regions={regions} />
                        </div>
                    )
                    
                })
            }
            
           
        </Container>
    )
}

export default ExpertCatReport;